import { render } from "./ProposalPdfPage.vue?vue&type=template&id=2840d6a2&scoped=true"
import script from "./ProposalPdfPage.vue?vue&type=script&lang=js"
export * from "./ProposalPdfPage.vue?vue&type=script&lang=js"

import "./ProposalPdfPage.vue?vue&type=style&index=0&id=2840d6a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2840d6a2"]])

export default __exports__